/*eslint max-lines: ["error", {"max": 450, "skipBlankLines": true, "skipComments": true}]*/
import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { I18NEXT_NAMESPACE_RESOLVER } from 'angular-i18next';
import { RoutingConfig } from 'routing.config';
import { AccessDeniedComponent } from 'shared/components/generic/access-denied/access-denied.component';
import { AccessDeniedRouteGuard } from 'shared/components/generic/access-denied/access-denied.route-guard';
import { NotFoundComponent } from 'shared/components/generic/not-found/not-found.component';
import { AuthorizedOnlyRouteGuard } from 'shared/routeGuards/authorized-only-route-guard';
import { API01V2RequestService } from './features/API01V2/API01V2-request.service';
import { NeedOpenCONF01V2RouteGuard } from './features/CONF01V2/routingGuard/need-open-conf01v2.route-guard';
import { NeedOpenAPI01V2RouteGuard } from './features/API01V2/routingGuard/need-open-api01v2.route-guard';

const routes: Routes = [
    {
        path: '',
        pathMatch: RoutingConfig.PathMatch.Full,
        redirectTo: RoutingConfig.RequestsList.Base
    },
    {
        path: 'department-task-list',
        pathMatch: RoutingConfig.PathMatch.Full,
        redirectTo: RoutingConfig.DepartmentTaskList.Base
    },
    {
        data: {
            i18nextNamespaces: ['API01V2']
        },
        loadChildren: () => import('./features/API01V2/API01V2.module').then(m => m.API01V2Module),
        path: RoutingConfig.API01V2.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard, NeedOpenAPI01V2RouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['API01']
        },
        loadChildren: () => import('./features/Middleware/API01/API01.module').then(m => m.API01Module),
        path: RoutingConfig.API01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['PS01']
        },
        loadChildren: () => import('./features/PS01/PS01.module').then(m => m.PS01Module),
        path: RoutingConfig.PS01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['PS02']
        },
        loadChildren: () => import('./features/PS02/PS02.module').then(m => m.PS02Module),
        path: RoutingConfig.PS02.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['REX01']
        },
        loadChildren: () => import('./features/REX01/REX01.module').then(m => m.REX01Module),
        path: RoutingConfig.REX01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CSC01']
        },
        loadChildren: () => import('./features/CSC01/CSC01.module').then(m => m.CSC01Module),
        path: RoutingConfig.CSC01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CSC03']
        },
        loadChildren: () => import('./features/CSC03/CSC03.module').then(m => m.CSC03Module),
        path: RoutingConfig.CSC03.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['GDS01']
        },
        loadChildren: () => import('./features/GDS01/GDS01.module').then(m => m.GDS01Module),
        path: RoutingConfig.GDS01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CCR01']
        },
        loadChildren: () => import('./features/CCR01/CCR01.module').then(m => m.CCR01Module),
        path: RoutingConfig.CCR01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['SP08']
        },
        loadChildren: () => import('./features/Sirena/SP08/SP08.module').then(m => m.SP08Module),
        path: RoutingConfig.SP08.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['SP04']
        },
        loadChildren: () => import('./features/Sirena/SP04/SP04.module').then(m => m.SP04Module),
        path: RoutingConfig.SP04.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CONF01V2']
        },
        loadChildren: () => import('./features/CONF01V2/CONF01V2.module').then(m => m.CONF01V2Module),
        path: RoutingConfig.CONF01V2.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard, NeedOpenCONF01V2RouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CONF01']
        },
        loadChildren: () => import('./features/CONF01/CONF01.module').then(m => m.CONF01Module),
        path: RoutingConfig.CONF01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['PASS01']
        },
        loadChildren: () => import('./features/PASS01/PASS01.module').then(m => m.PASS01Module),
        path: RoutingConfig.PASS01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['AA02']
        },
        loadChildren: () => import('./features/AA02/AA02.module').then(m => m.AA02Module),
        path: RoutingConfig.AA02.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['AA03']
        },
        loadChildren: () => import('./features/AA03/AA03.module').then(m => m.AA03Module),
        path: RoutingConfig.AA03.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['CP01']
        },
        loadChildren: () => import('./features/CP01/CP01.module').then(m => m.CP01Module),
        path: RoutingConfig.CP01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['SR01']
        },
        loadChildren: () => import('./features/SR01/SR01.module').then(m => m.SR01Module),
        path: RoutingConfig.SR01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['BSP01']
        },
        loadChildren: () => import('./features/BSP01/BSP01.module').then(m => m.BSP01Module),
        path: RoutingConfig.BSP01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['SR03']
        },
        loadChildren: () => import('./features/SR03/SR03.module').then(m => m.SR03Module),
        path: RoutingConfig.SR03.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['PR03']
        },
        loadChildren: () => import('./features/PR03/PR03.module').then(m => m.PR03Module),
        path: RoutingConfig.PR03.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['AA01']
        },
        loadChildren: () => import('./features/AA01/AA01.module').then(m => m.AA01Module),
        path: RoutingConfig.AA01.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['BSP03']
        },
        loadChildren: () => import('./features/BSP03/BSP03.module').then(m => m.BSP03Module),
        path: RoutingConfig.BSP03.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        }
    },
    {
        data: {
            i18nextNamespaces: ['request-list']
        },
        loadChildren: () => import('./features/Registries/request-list/request-list.module').then(m => m.RequestListModule),
        path: RoutingConfig.RequestsList.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        data: {
            i18nextNamespaces: ['request-list']
        },
        loadChildren: () => import('./features/Registries/department-task-list/department-task-list.module').then(m => m.DepartmentTaskListModule),
        path: RoutingConfig.DepartmentTaskList.Base,
        resolve: {
            i18next: I18NEXT_NAMESPACE_RESOLVER
        },
        canActivate: [AuthorizedOnlyRouteGuard]
    },
    {
        path: 'auth/ccr01/new',
        redirectTo: 'ccr01/new'
    },
    {
        path: 'auth/bsp01/new',
        redirectTo: 'bsp01/new'
    },
    {
        path: 'auth/aa01/new',
        redirectTo: 'aa01/new'
    },
    {
        canActivate: [AccessDeniedRouteGuard],
        component: AccessDeniedComponent,
        path: 'access-denied'
    },
    {
        path: '**',
        redirectTo: 'not-found'
    },
    {
        component: NotFoundComponent,
        path: 'not-found'
    }
];

@NgModule({
    exports: [RouterModule],
    imports: [
        RouterModule.forRoot(routes, {
    preloadingStrategy: NoPreloading,
    scrollPositionRestoration: 'top',
    useHash: false
})
    ],
    providers: [API01V2RequestService, AccessDeniedRouteGuard, AuthorizedOnlyRouteGuard, NeedOpenCONF01V2RouteGuard, NeedOpenAPI01V2RouteGuard]
})
export class AppRoutingModule {}
